import { apiQaroniEnvironment } from './../../../../environments/environment';

export const ApiQaroniEnv = {
  URLBase: Object.prototype.hasOwnProperty.call(apiQaroniEnvironment, 'URLBase')
    ? apiQaroniEnvironment.URLBase
    : null,
};
